export const LOAD_CONTENT = 'hg/myplan/LOAD_CONTENT';
export const DL_PAGE_LOADED = 'hg/myplan/DL_PAGE_LOADED';

export const loadContent = () => {
  return {
    type: LOAD_CONTENT
  };
};



/** WEBPACK FOOTER **
 ** ./client/redux/modules/pages/MyPlan/myplan/myplan.js
 **/